import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const sendReminders = async (reports: string) => {
  const url = `${getFunctionBaseUrl()}/api/sendReminders/${reports}/`;
  const response = await rest.get(url);
  return response;
}